import { tsValidateOptionalId, tsValidator_nonMandatoryString } from '@nu-art/ts-common';
const Validator_ModifiableProps = {
    firstName: tsValidator_nonMandatoryString,
    surname: tsValidator_nonMandatoryString,
    title: tsValidator_nonMandatoryString,
    thumbnailUrl: tsValidator_nonMandatoryString,
    orgId: tsValidateOptionalId,
};
const Validator_GeneratedProps = {};
export const DBDef_User = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'users',
    entityName: 'User',
    frontend: {
        group: 'account',
        name: 'user'
    },
    backend: {
        name: 'users'
    },
    dependencies: {
        _id: {
            dbKey: 'user-account--accounts',
            fieldType: 'string'
        }
    }
};
//# sourceMappingURL=db-def.js.map